/**
 * VisualizadorPeca — desenho da peça com seletor 2D/3D.
 *
 * Usado na REVISÃO do wizard (colaborador confere antes de enviar). A
 * Gestão tem o equivalente embutido no `CarrosselPecasFita`, cujo layout de
 * carrossel não cabe aqui.
 *
 * PADRÃO 2D de propósito: este wizard roda no celular do montador, no 4G da
 * obra, e o 3D arrasta o three.js (~570 KB). Deixá-lo automático encareceria
 * TODA solicitação enviada; como toggle, quem quer conferir o volume paga o
 * download só quando pede. Trocar o padrão é uma linha (`useState("3d")`).
 *
 * O 3D precisa saber se o material tem veio, e na revisão a peça ainda não
 * existe no banco — o dado vem do item escolhido no combobox de materiais
 * (`materiais-select` passou a devolver `tem_veio`). Sem isso, madeirado
 * apareceria liso justamente na tela onde a pessoa aprova a peça.
 */
import React, { Suspense, lazy, useState } from "react";

import VisualPecaFita from "./VisualPecaFita";
import { PrevisaoPalco, PrevisaoSeletor } from "./styles";

const Peca3D = lazy(() => import("../../PecaPublica/Peca3D"));

export default function VisualizadorPeca({ peca, materiais, altura = "300px" }) {
  const [modo, setModo] = useState("2d");

  const material = (materiais || []).find(
    (m) => String(m.id) === String(peca?.material_id),
  );
  // `cor` descreve melhor a cor que a `descricao` ("MDF Gianduia Puro");
  // é dela que sai a paleta do 3D.
  const pecaPara3D = {
    ...peca,
    material_nome: material?.cor || peca?.material_nome || "",
    material_tem_veio: Boolean(material?.tem_veio),
  };

  return (
    <PrevisaoPalco>
      <PrevisaoSeletor role="group" aria-label="Modo de visualização da peça">
        <button type="button" data-on={modo === "2d"} onClick={() => setModo("2d")}>
          2D
        </button>
        <button type="button" data-on={modo === "3d"} onClick={() => setModo("3d")}>
          3D
        </button>
      </PrevisaoSeletor>

      {modo === "3d" ? (
        <Suspense
          fallback={
            <div className="carregando" style={{ height: altura }}>
              Preparando o 3D…
            </div>
          }
        >
          <Peca3D peca={pecaPara3D} altura={altura} />
        </Suspense>
      ) : (
        <VisualPecaFita peca={peca} />
      )}
    </PrevisaoPalco>
  );
}
